import type { GetPreferencesResponse } from '~~/server/api/preferences/index.get';

export default defineNuxtPlugin({
  name: 'authorization-resolver',
  parallel: true,
  async setup() {
    const {
      data: { value: sessionInfo },
    } = await useAuthSession();

    const preferences = sessionInfo?.session?.activeOrganizationId
      ? await $fetch<GetPreferencesResponse>('/api/preferences', {
          headers: useRequestHeaders(['cookie']),
        })
      : undefined;

    return {
      provide: {
        authorization: {
          resolveClientUser: () => ({
            user: sessionInfo?.user,
            session: sessionInfo?.session,
            member: preferences?.member,
            userPreferences: preferences?.user,
            organizationPreferences: preferences?.organization,
          }),
        },
      },
    };
  },
});
